import './index.scss'

$(".hamburger").click(function(){
    $(this).toggleClass("active");
    $(".mob-nav").toggleClass("active");
})
$(".mob-nav .nLi").click(function() {
    $(this).find(".sub").slideToggle();
    $(this).toggleClass("active");
})
$(".nav li").hover(function(){
    $(this).find(".li-drop").stop().slideDown();
    $(this).addClass("active");
},function(){
    $(this).find(".li-drop").stop().slideUp();
    $(this).removeClass("active");
})